module.exports = __webpack_public_path__ + "media/theme/tutorial__reco--2--create-54e7eb2e.png";